import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";

// This build intentionally has no service worker. Remove only known legacy CRA/
// Whisper workers from the same origin so an obsolete deployment cannot keep
// serving an old JS bundle. Unrelated registrations and cache names are untouched.
const removeLegacyWhisperServiceWorker = async () => {
  if (!("serviceWorker" in navigator)) return;
  try {
    const registrations = await navigator.serviceWorker.getRegistrations();
    const staleRegistrations = registrations.filter((registration) => {
      const worker = registration.active || registration.waiting || registration.installing;
      if (!worker?.scriptURL) return false;
      const script = new URL(worker.scriptURL, window.location.href);
      const scope = new URL(registration.scope, window.location.href);
      const scopeCoversCurrentPage = window.location.href.startsWith(scope.href);
      return script.origin === window.location.origin
        && scope.origin === window.location.origin
        && scopeCoversCurrentPage
        && /\/(?:service-worker|sw)\.js$/i.test(script.pathname);
    });
    if (!staleRegistrations.length) return;
    const results = await Promise.all(staleRegistrations.map((registration) => registration.unregister()));
    if (!results.some(Boolean) || !("caches" in window)) return;
    const names = await window.caches.keys();
    const currentHost = window.location.host.toLowerCase();
    await Promise.all(names
      .filter((name) => {
        const normalized = name.toLowerCase();
        if (/^whisper-(?:precache|static|runtime)/i.test(name)) return true;
        return /^(?:workbox-precache|precache-)/i.test(name) && normalized.includes(currentHost);
      })
      .map((name) => window.caches.delete(name)));
  } catch {
    // Cache cleanup must never delay or prevent application startup.
  }
};

window.addEventListener("load", removeLegacyWhisperServiceWorker, { once: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
